document.addEventListener('DOMContentLoaded', function () {
  const collectionGridContanier = document.querySelector('#ProductGridContainer');
  const loadingWrapper = collectionGridContanier.querySelector('.collection');
  const labels = document.querySelectorAll('.filters > label');
  const clearWrap = document.querySelector('.filters.clearall-filter')

  labels.forEach(label => {
    label.addEventListener('click', function (event) {
      event.preventDefault();

      const el = this.closest('.filters');
      if (!el) return;
      const siblings = Array.from(el.parentElement.children).filter(
        sib => sib !== el && sib.classList.contains('filters')
      );
      siblings.forEach(sib => sib.classList.remove('active'));
      el.classList.toggle('active');

      if (typeof togglePadding === 'function') {
        togglePadding();
      }
    });
  });

  const singleTags = document.querySelectorAll('.single-tag');
    singleTags.forEach(tag => {
      tag.addEventListener('click', function (event) {
        
        clearWrap.classList.add('active');

        const el = event.currentTarget;
        const valueHandle = el.dataset.tagHandle;
        const valueTag = el.dataset.tag;

        let baseUrl;

if (window.location.pathname.includes('green-beans')) {
  baseUrl = window.location.pathname.split('?')[0];
} else {
  baseUrl = '/collections/shop-all';
}
        const url = new URL(baseUrl, window.location.origin);

        if (valueTag) {
          url.searchParams.append('filter.p.tag', valueTag);
        }
        if (valueHandle) {
          url.searchParams.append('filter.p.tag', valueHandle);
        }
        const targetUrl = url.toString();
        console.log('Filtered URL:', targetUrl);


        const productGrid = collectionGridContanier.querySelector('#product-grid');
        if (el.classList.contains('disabled')) {
          const clearAll = document.querySelector('.clearall-filter .clearall');
          if (clearAll) clearAll.click();
          el.classList.remove('disabled');
          return;
        }

        loadContent(targetUrl,'#ProductGridContainer .collection',loadingWrapper)
        document.querySelectorAll('.single-tag').forEach(tag => {
          tag.classList.add('weselected');
          tag.classList.remove('disabled');
        });

        el.classList.remove('weselected');
        el.classList.add('disabled');

      });
    });
    const clearBtn = document.querySelector('.clearall-filter .clearall');
    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        clearFilters(); 
        clearWrap.classList.remove('active');

      });
    }

    const sortSelect = document.querySelector('#SortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);

        const targetUrl = url.toString();
        window.history.replaceState({}, '', targetUrl);

        loadContent(targetUrl, '#ProductGridContainer .collection', loadingWrapper);
      });
    }

});




 function togglePadding() {
    const filterContainer = document.querySelector('#collection-tools-container');
    const activeFilter = document.querySelector('.filters.active');

    if (!filterContainer) return;

    if (activeFilter) {
      const filterTags = activeFilter.querySelector('.filter-tags');
      const filterHeight = filterTags ? filterTags.offsetHeight : 0;
      filterContainer.style.paddingBottom = filterHeight + 'px';
    } else {
      filterContainer.style.paddingBottom = '';
    }
  }

function clearFilters(containerSelector) {
  const scope = containerSelector ? document.querySelector(containerSelector) : document;
  if (!scope) return;

  scope.querySelectorAll('.single-tag').forEach(el => {
    el.classList.remove('weselected', 'disabled');
  });

  if (typeof togglePadding === 'function') togglePadding();

  const currentUrl = window.location.href;
  const gridContainer  = document.querySelector('#ProductGridContainer');
  const loadingWrapper = gridContainer ? gridContainer.querySelector('.collection') : null;

  if (gridContainer && loadingWrapper) {
    loadContent(currentUrl, '#ProductGridContainer .collection', loadingWrapper);
  }
}




  function loadContent(url, selector,loadingWrapper) {
    loadingWrapper.classList.add('loading');
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const fetchedElement = doc.querySelector(selector);
        if (!fetchedElement) {
          return;
        }

        const targetElement = document.querySelector(selector);
        if (!targetElement) {
          return;
        }

        // Replace the target content with the fetched content
        targetElement.innerHTML = fetchedElement.innerHTML;
        loadingWrapper.classList.remove('loading');

      })
      .catch(error => {
        console.error('Error loading content:', error);
      });
  }
